import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Projects } from '../../models/itens.model';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';

@Component({
  selector: 'app-itens-ac-projects',
  templateUrl: './itens-ac-projects.component.html',
  styleUrls: ['./itens-ac-projects.component.scss','../itens-edit/itens-edit.component.scss']
})
export class ItensAcProjectsComponent extends BaseFormComponent<Projects> implements OnInit {
  @Input() parentFormGroup: FormGroup = null;
  @Input() expand: boolean = false;
  @Input() check: boolean = false;
  @Input() order: boolean = false;
  @Input() currentItem: object[] = [];
  @Output() checkStatus = new EventEmitter<boolean>();
  @Output() orderItem = new EventEmitter<any>();
  constructor(
    public activatedRoute: ActivatedRoute,
  ) { 
    super(activatedRoute);
  }
  ngOnInit() {
  }
  getFormArray(id:number){
    return this.acProjects.controls[id]?.get('acPrtIssuesCommon') as FormGroup;
  }
  get acProjects(): FormArray {
    return this.parentFormGroup.get('acProjects') as FormArray;
  }
  onCheckStatus(){
    this.checkStatus.emit(true)
  }
  onOrderItem(e){
    this.orderItem.emit(e)
  }
}
